import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IHasPendingUploads } from 'src/app/shared/model/has-pending-uploads';
import { PendingUploadDialogComponent } from 'src/app/shared/components/pending-upload-dialog/pending-upload-dialog.component';

/**
 * Related to embedded dynamic form doing document uploading...
 * Route `canDeactivate` guard that blocks navigation when the active route component
 * has a file selected but not yet uploaded.
 *
 * Any route component that hosts a Dynamic Forms upload element should implement
 * `HasPendingUploads` and be protected by this guard.
 *
 * When pending uploads are detected the guard opens a confirmation dialog.
 * Navigation proceeds only if the user confirms.
 */
export const pendingUploadsGuard: CanDeactivateFn<IHasPendingUploads> = (
  component: IHasPendingUploads,
): Observable<boolean> | boolean => {
  if (!component.hasPendingUploads()) {
    return true;
  }

  const dialog = inject(MatDialog);

  return dialog
    .open<PendingUploadDialogComponent, void, boolean>(
      PendingUploadDialogComponent,
    )
    .afterClosed()
    .pipe(map((confirmed) => confirmed === true));
};
